<template>
  <v-app>
    <v-content>
      <router-view />
    </v-content>
  </v-app>
</template>

<script>
export default {
  name: 'authLayout'
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/layouts/authLayout.vue